import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HttpClient} from '@angular/common/http';

import {SelectItem} from 'primeng/primeng';
import {Message} from "primeng/components/common/api";

import * as $ from 'jquery';
import * as _ from 'lodash';
import * as moment from 'moment';

import {Router} from "@angular/router";

import {Post} from '../../api/model/post';
import {Image} from "../../api/model/image";
import {AwsService} from "../aws.service";
import {Utils} from '../utils';
import {config} from '../config';
import * as jodit_es from '../jodit-es';

const slugize = require('hexo-util/lib/slugize');
const Permalink = require('hexo-util/lib/permalink');

declare var Jodit: any;

@Component({
    template: require('./post-form.component.pug'),
    styles: [require('./post-form.component.css')]
})
export class PostFormComponent implements OnInit, AfterViewInit {
    msgs: Message[] = [];

    @ViewChild('editor') el: ElementRef;
    private _editor: any;

    action: string = 'create';
    siteId: string;
    siteUrl: string;
    sitePreview: string;
    permalink: string;

    publishConfirm: boolean = false;
    uploadConfirm: boolean = false;

    model: Post = {layout: 'post', categories: [], tags: [], images: [], seo: {}};
    slug: string;

    categories: SelectItem[] = [];
    selectedCategory: string;

    tags: SelectItem[] = [];
    selectedTag: string;

    createdAt: Date;

    selectedImage: Image = {};


    private _imageBaseUrl: string;
    private _imageFilename: string;

    constructor(private route: ActivatedRoute, private _router: Router, private _awsService: AwsService, private _httpClient: HttpClient) {
        console.log('[PostFormComponent][constructor]');
        this.siteId = localStorage.getItem('currentSite');
    }

    async ngOnInit() {
        console.log('[PostFormComponent][ngOnInit]');

        try {
            let site = (await this._awsService.api.sitesSiteGet({site: this.siteId})).data;
            let schema = (site.ssl) ? 'https://' : 'http://';
            let domain = (site.cname) ? site.cname : site.id + '.sintesis.io';
            this.siteUrl = schema + domain + '/';
            this.sitePreview = 'https://' + site.id + '.preview.sintesis.io/';

            let id = this.route.snapshot.paramMap.get("id");
            if (id !== "new") {
                this.model = (await this._awsService.api.sitesSitePostsSlugGet({site: this.siteId, slug: id})).data;
                console.log(this.model);
                this.fromModel();
                this.action = 'update';
            }

            // Obtenemos todas las categorias que hay en los posts del site
            let categories = (await this._awsService.api.sitesSitePostsCategoriesGet({site: this.siteId})).data.items;
            _.pullAll(categories, this.model.categories); // Quitamos las que ya tiene el post
            this.categories = [{label: '', value: null}];
            for (let category of categories) this.categories.push({label: category, value: category});

            // Obtenemos todas las etiquetas que hay en los posts del site
            let tags = (await this._awsService.api.sitesSitePostsTagsGet({site: this.siteId})).data.items;
            _.pullAll(tags, this.model.tags);  // Quitamos las que ya tiene el post
            this.tags = [{label: '', value: null}];
            for (let tag of tags) this.tags.push({label: tag, value: tag});
        } catch (err) {
            this.msgs.push({severity: 'error', summary: 'Error en la carga'});
        }


    
    
  }

    ngAfterViewInit(): void {
        console.log('[PostFormComponent][ngAfterViewInit]', jodit_es);
        const editorOps:any = {
            
            language: 'es',
            //debugLanguage: true,
            i18n: {es: jodit_es.default},
            buttons: ['source', '|', 'bold', 'italic', '|', 'ul', 'ol', '|', 'font', 'fontsize', 'brush', 'paragraph', '|', 'image', 'video', 'table', 'link', '|', 'align', '|', 'undo', 'redo', '|', 'hr', 'eraser', 'fullsize'],
            uploader: {
                url: config.S3_ENDPOINT,
                format: 'text',
                prepareData: async (formData: FormData) => {
                    if (formData.has('files[0]')) {
                        let file: any = formData.get('files[0]');
                        let filename = slugize(Utils.basename(file.name)) + '.' + Utils.extension(file.name);
                        let path = config.S3_PREFIX + this._awsService.identityId + '/posts/up/';
                        let params = {
                            Bucket: config.S3_BUCKET,
                            Fields: {
                                key: path + filename,
                                acl: 'public-read',
                                success_action_status: '200'
                            }
                        };
                        const s3 = new this._awsService.AWS.S3(this._awsService.credentials);
                        let data = await (new Promise<any>((res, rej) => {
                            s3.createPresignedPost(params, (err: any, data: any) => (err) ? rej(err) : res(data));
                        }));
                        for (let key of Object.keys(data.fields)) {
                            formData.set(key, data.fields[key]);
                        }
                        formData.append('file', file);
                        this._imageBaseUrl = data.url + '/';
                        this._imageFilename = path + filename;
                    }
                    formData.delete('path');
                    formData.delete('source');
                    formData.delete('files[0]');
                    return formData;
                },
                getMessage: (resp: any) => {
                    return "OK";
                },
                isSuccess: (resp: any) => {
                    return true;
                },
                process: (resp: any, data: any) => {
                    return {
                        files: resp.files || [this._imageFilename],
                        path: resp.path,
                        baseurl: resp.baseurl || this._imageBaseUrl,
                        error: resp.error,
                        msg: resp.msg
                    }
                }
            },
            height: 600,
            allowResizeX: false,
            allowResizeY: false
        };
        this._editor = new Jodit(this.el.nativeElement, editorOps);
        this._editor.setEditorValue(this.model.content);

    };

    fromModel() {
        this._editor.setEditorValue(this.model.content);
        if (!this.model.categories) this.model.categories = [];
        if (!this.model.tags) this.model.tags = [];
        if (!this.model.images) this.model.images = [];
        if (!this.model.seo) this.model.seo = {};
        if (!this.model.seo.title) this.model.seo.title = this.model.title;
        if (this.model.createdAt) this.model.createdAt = moment(this.model.createdAt).toDate();
        if (this.model.updatedAt) this.model.updatedAt = moment(this.model.updatedAt).toDate();
        this.slug = this.model.slug;
        this.updatePermalink();
    }

    toModel() {
        if (!this.model.slug) this.model.slug = slugize(this.model.title);
        this.model.content = this._editor.getEditorValue();
    }

    onChangeTitle(title: string) {
        if (this.model.slug === this.model.title || this.model.slug === slugize(this.model.title)) {
            this.model.slug = slugize(title);
        }
        if (this.model.seo.title === this.model.title) {
            this.model.seo.title = title;
        }
        this.model.title = title;
        this.updatePermalink();
    }

    onChangeSlug(slug: string) {
        this.updatePermalink();
    }

    updatePermalink() {
        let date = (this.model.createdAt) ? moment(this.model.createdAt) : moment();
        let meta = {
            id: this.model.slug || '',
            title: this.model.slug,
            name: '',
            post_title: slugize(this.model.title, {transform: 1}),
            year: date.format('YYYY'),
            month: date.format('MM'),
            day: date.format('DD'),
            i_month: date.format('M'),
            i_day: date.format('D')
        };
        let permalink = new Permalink(':year/:month/:day/:title/');
        this.permalink = permalink.stringify(meta, {});
    }

    async save() {
        this.msgs = [];
        this.toModel();
        if (this.action == 'create') {
            try {
                const params = {site: this.siteId, slug: this.model.slug};
                await this._awsService.api.sitesSitePostsSlugHead(params);
                this.msgs.push({severity: 'error', summary: 'La url ya existe'});
            } catch (err) {
            }
            try {
                this.model = (await this._awsService.api.sitesSitePostsPost({site: this.siteId}, this.model)).data;
                this.action = 'update';
                this.fromModel();
                this.msgs.push({severity: 'success', summary: 'El Post se ha guardado'});
                setTimeout(()=>{
                    this.msgs.pop();
                }, 4000);
            } catch (err) {
                this.msgs.push({severity: 'error', summary: 'Error al guardar el post'});
                return;
            }
        } else if (this.action == 'update') {
            const additionalParams:any = {queryParams: {}};
            if (this.slug !== this.model.slug) {
                try {
                    const params = {site: this.siteId, slug: this.model.slug};
                    await this._awsService.api.sitesSitePostsSlugHead(params);
                    this.msgs.push({severity: 'error', summary: 'La url ya existe'});
                    return;
                } catch (err) {
                    additionalParams.queryParams.slug = this.model.slug;
                }
            }
            try {
                const params = {site: this.siteId, slug: this.slug};
                this.model = (await this._awsService.api.sitesSitePostsSlugPut(params, this.model, additionalParams)).data;
                this.fromModel();
                this.msgs.push({severity: 'success', summary: 'El Post se ha actualizado correctamente'});
                setTimeout(()=>{
                    this.msgs.pop();
                }, 3000);
            } catch (err) {
                this.msgs.push({severity: 'error', summary: 'Error en la actualización'});
                return;
            }
        }
    }

    async uploadHandler(event: any, uploader: any) {
        this.msgs = [];
        try {
            const s3 = new this._awsService.AWS.S3(this._awsService.credentials);
            const path = config.S3_PREFIX + this._awsService.identityId + '/posts/up/';
            const filename = slugize(Utils.basename(event.files[0].name)) + '.' + Utils.extension(event.files[0].name);
            const key = path + filename;
            const params = {Bucket: config.S3_BUCKET, Key: key, Body: event.files[0], ACL: 'public-read'};
            const data = await s3.upload(params).promise();
            const image = _.find(this.model.images, {name: filename});
            if (!image) this.model.images.push({name: filename, url: data.Location});
            uploader.clear();
            this.msgs.push({severity: 'success', summary: 'La imagen se ha subido correctamente'});
            setTimeout(()=>{
                    this.msgs.pop();
                }, 3000);
        } catch (err) {
            this.msgs.push({severity: 'error', summary: 'Error en la subida de la imagen, revise que sea de menos de 1 mega'});
        }
    }

    addCategories() {
        if (_.isEmpty(this.selectedCategory)) return;
        let temp: string[] = this.model.categories;
        let values: string[] = this.selectedCategory.split(',');
        for (let val of values) {
            if (_.isEmpty(val.trim())) continue;
            temp.push(val.trim());
        }
        this.model.categories = _.uniq(temp);
        this.selectedCategory = null;
    }

    addTags() {
        if (_.isEmpty(this.selectedTag)) return;
        let temp: string[] = this.model.tags;
        let values: string[] = this.selectedTag.split(',');
        for (let val of values) {
            if (_.isEmpty(val.trim())) continue;
            temp.push(val.trim());
        }
        this.model.tags = _.uniq(temp);
        this.selectedTag = null;
    }


    removeImage(image: Image) {
        _.remove(this.model.images, (img) => (img.name === image.name));
    }

    updateImage() {
        this.selectedImage = {};
    }

    async publish() {
        this.msgs = [];
        if (!this.model.slug || !this.model.site) return;
        try {
            this.model.published = true;
            this.model.publishedAt = new Date();
            const params = {site: this.model.site, slug: this.model.slug};
            this.model = (await this._awsService.api.sitesSitePostsSlugPut(params, this.model)).data;
            this.fromModel();
            this.msgs.push({severity: 'success', summary: 'El Post está preparado'});
        } catch (err) {
            this.msgs.push({severity: 'error', summary: 'Error en la publicación'});
        }
    }

    async publishSite() {
        this.msgs = [];
        const currentSite = localStorage.getItem('currentSite');
        if (!currentSite) return;
        try {
            const url = 'https://sites.sintesis.io/deploy/' + config.STAGE + '/site/' + currentSite + '/publish';
            const res = await this._httpClient.get(url).toPromise();
            console.log(res);
            let siteUrl = 'https://' +currentSite;
            if (config.STAGE !== 'prod') siteUrl += '-' + config.STAGE;
            siteUrl += '.sintesis.io/';
            console.log(siteUrl);
            this.publishConfirm = true;
            this.msgs.push({severity: 'success', summary: 'El Post se ha publicado correctamente'});
            this.uploadConfirm = false;
        } catch (err) {
            this.msgs.push({severity: 'error', summary: 'Error en la publicación'});
        }
    }


    async unpublish() {
        this.msgs = [];
        if (!this.model.slug || !this.model.site) return;
        try {
            this.model.published = false;
            const params = {site: this.model.site, slug: this.model.slug};
            this.model = (await this._awsService.api.sitesSitePostsSlugPut(params, this.model)).data;
            this.fromModel();
            this.msgs.push({severity: 'success', summary: 'El Post se ha despublicado correctamente'});
            setTimeout(()=>{
                    this.msgs.pop();
                }, 3000);
        } catch (err) {
            this.msgs.push({severity: 'error', summary: 'No se ha podido despublicar el post.'});
        }
    }

    async confirmUpload() {
        await this.save();
        this.uploadConfirm = true;
        await this.publish();
        await this.publishSite();
        console.log(this.uploadConfirm);
    }
    
      
    

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/posts/post-form.component.ts